import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC } from 'react';
import Image from './Image';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { newsBorderColor, tertiaryColor } from 'src/constants/stylesheet';
import { Link } from 'react-router-dom';
import { formatDate } from './Home';
import useRouter from 'use-react-router';
import * as classNames from 'classnames';
import fonts from 'src/constants/fonts';
import Sharer from './Sharer';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      maxWidth: spacing.websiteMaxWidth,
      margin: '0 auto',
      color: tertiaryColor,

      [mediaQueries.Mobile]: {
        paddingLeft: spacing.Gutter.Mobile,
        paddingRight: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile * 2,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.Gutter.Tablet,
        paddingRight: spacing.Gutter.Tablet,
        paddingBottom: spacing.Gutter.Tablet * 2,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.Gutter.Laptop,
        paddingRight: spacing.Gutter.Laptop,
        paddingBottom: spacing.Gutter.Laptop * 2
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.Gutter.Desktop,
        paddingRight: spacing.Gutter.Desktop,
        paddingBottom: spacing.Gutter.Desktop * 2,
      },
    },
    backLinkOuter: {

      [mediaQueries.Mobile]: {
        paddingTop: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingTop: spacing.Gutter.Tablet,
        paddingBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        paddingTop: spacing.Gutter.Laptop,
        paddingBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        paddingTop: spacing.Gutter.Laptop,
        paddingBottom: spacing.Gutter.Laptop,
      },
    },
    backLink: {
      color: tertiaryColor
    },
    newsEntry: {
      border: `1px solid ${newsBorderColor}`,
      [mediaQueries.Mobile]: {
        padding: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        padding: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        padding: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        padding: spacing.Gutter.Laptop,
      },
    },
    newsEntryHeader: {
      display: 'flex',
    },
    newsEntryHeaderContent: {
      flex: '1 1 auto'
    },
    newsEntrySharerContainer: {
      flex: '0 0 auto',
      position: 'relative',
    },
    imageContainer: {
      [mediaQueries.Mobile]: {
        marginBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        marginBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        marginBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        marginBottom: spacing.Gutter.Laptop,
      },
    },
    title: {
      ...stylesheet.NewsMainTitle
    },
    titleMargin: {
      marginBottom: 10
    },
    date: {
      fontSize: '.85rem',
      ...fonts.light,
    },
    previewText: {
      ...fonts.light,

      [mediaQueries.Mobile]: {
        marginBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        marginBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        marginBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        marginBottom: spacing.Gutter.Laptop,
      },
    },
    text: {
      ...fonts.light,
    },
    main: {},
  }));
export type NewsEntryProps = NewsEntryDto;

type Props = NewsEntryProps;

const NewsEntry: FC<Props> = ({ Title, Image: image, Leaves, Date, PreviewText }) => {
  const cls = useStyles();
  const { location: { pathname } } = useRouter();
  const newsOverview = pathname.split("/")[1];

  const sizes = '(max-width: 1023px) 100vw, 400px'

  return (
    <div className={cls.root}>
      <div className={cls.backLinkOuter}>
        <Link to={`/${newsOverview}`} className={cls.backLink}>All posts</Link>
      </div>
      <article className={cls.newsEntry}>
        <header className={cls.newsEntryHeader}>
          <div className={cls.newsEntryHeaderContent}>
            <div className={cls.date}>{formatDate(Date)}</div>
            <h1 className={classNames(cls.title, cls.titleMargin)}>{Title}</h1>
            <div className={cls.previewText} dangerouslySetInnerHTML={{ __html: PreviewText }} />
          </div>
          <div className={cls.newsEntrySharerContainer}>
            <Sharer url={window.location.href} />
          </div>
        </header>
        <div className={cls.main}>
          {Leaves.map((leaf, i) => {

            switch (leaf.type) {

              case 'NewsItemImage':
                const imagePanel = leaf as NewsItemImageDto;
                return (
                  <div key={`image-panel-${i}`} className={cls.imageContainer}>
                    <Image pictureRef={imagePanel.Image} sizes={sizes} />
                  </div>
                );

              case 'NewsItemText':
                const textPanel = leaf as NewsItemTextDto;
                return (
                  <div
                    key={`image-text-${i}`}
                    className={cls.text}
                    dangerouslySetInnerHTML={{ __html: textPanel.Text }}
                  />);

              default:
                return undefined;
            }
          })}
        </div>
      </article>
    </div>
  );
};

export default NewsEntry;


// WEBPACK FOOTER //
// ./src/Components/NewsEntry.tsx